import { render, staticRenderFns } from "./MTextFieldComp.vue?vue&type=template&id=2c0b1946&"
import script from "./MTextFieldComp.vue?vue&type=script&lang=js&"
export * from "./MTextFieldComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports